<p>hotel-cancellation works!</p>
<!-- 
<div class="qodefwrap" *ngIf="!isLoading; else showError">
    <div class="booking-container paymentpage">
        <div class="container nopad">
            <div class="payment_div">
                <div class="container nopad">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12 col-sm-12 nopad fulbuki ">
                                <div class="reassurance">
                                    <div class="valign-wrapper">
                                        <div class="col-md-9">
                                            <div class="reassurance_cell-text">
                                                <h1 class="reassurance__title">
                                                    Your booking in {{canceledData['BookingDetails']['HotelName']}} has
                                                    been cancelled. <br>
                                                    <span style="font-size:16px;color: #000; ">
                                                        For your reference, your Booking ID is
                                                        <span style="color: #4169e1;">
                                                            {{canceledData['BookingDetails']['AppReference'] +' / '+ canceledData['BookingDetails']['ConfirmationReference']}}
                                                        </span>
                                                    </span>
                                                </h1>
                                                <ul class="reassurance__list">
                                                    <li>
                                                        We've sent your cancel confirmation email to
                                                        <strong>
                                                            {{canceledData['BookingPaxDetails'][canceledData['BookingPaxDetails'].length-1]['Email']}}
                                                        </strong>
                                                    </li>
                                                    <li>
                                                        Cancelled on
                                                        <strong>
                                                            {{getDate(canceledData['BookingDetails']['CancelledDatetime'])}}, 
                                                            {{getTimes(canceledData['BookingDetails']['CancelledDatetime'])}}
                                                        </strong>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="cancel_vector"><img src="assets/images/hotel_cancel.png"></div>
                                            <div class="cancledhead">
                                                <h1>cancelled</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="redetails">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="farehd arimobold" style="margin-top: 0px;">Hotel Details</div>
                                        <div class="reassure">
                                            <div class="book_check">
                                                <div class="cancledhead"
                                                    style="position: absolute; right: 40px; top: 45px">
                                                    <h1>cancelled</h1>
                                                </div>
                                                <div class="imptpldz">
                                                    <div class="property-type" data-property-type="hotel"></div>
                                                    <div class="shtlnamehotl">
                                                        <span class="h-name">
                                                            <a href="javascript:void(0);">
                                                                {{canceledData['BookingDetails']['HotelName']}}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="adreshotle h-adr" data-toggle="tooltip"
                                                        data-placement="top" data-original-title="" title="">
                                                        <ul>
                                                            <li class=""><i class="fal fa-phone"></i>
                                                                {{canceledData['BookingDetails']['PhoneNumber']}}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="adreshotle h-adr"
                                                        tooltip="{{canceledData['BookingDetails']['HotelAddress']}}"
                                                        data-placement="top">
                                                        {{canceledData['BookingDetails']['HotelAddress']}}
                                                        {{canceledData['BookingDetails'].PinCode ? ', '+canceledData['BookingDetails'].PinCode : '' }}
                                                        {{canceledData['BookingDetails'].City ? ' '+canceledData['BookingDetails'].City : ''}}
                                                        {{canceledData['BookingDetails'].CountryName ? ', '+canceledData['BookingDetails'].CountryName : ''}}
                                                    </div>
                                                    <div class="clearfix"></div>
                                                    <div class="sckint">
                                                        <div class="ffty"
                                                            *ngIf="getDatesFormat(canceledData['BookingDetails']['HotelCheckIn'], 'in')">
                                                            <div class="borddo brdrit">
                                                                <span class="lblbk_book"><span
                                                                        class="far fa-calendar-alt"></span>Check-in</span>
                                                                <div class="biginre_book">
                                                                    {{canceledData['BookingDetails']['myCheckinDateTime']['day']}}
                                                                    <span class="bigdate_book">
                                                                        {{canceledData['BookingDetails']['myCheckinDateTime']['d']}}
                                                                        {{canceledData['BookingDetails']['myCheckinDateTime']['m']}}
                                                                    </span>
                                                                    {{canceledData['BookingDetails']['myCheckinDateTime']['y']}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="ffty"
                                                            *ngIf="getDatesFormat(canceledData['BookingDetails']['HotelCheckOut'], 'out')">
                                                            <div class="borddo">
                                                                <span class="lblbk_book"> <span
                                                                        class="far fa-calendar-alt"></span>
                                                                    Check-out</span>
                                                                <div class="biginre_book">
                                                                    {{canceledData['BookingDetails']['myCheckoutDateTime']['day']}}
                                                                    <span class="bigdate_book">
                                                                        {{canceledData['BookingDetails']['myCheckoutDateTime']['d']}}
                                                                        {{canceledData['BookingDetails']['myCheckoutDateTime']['m']}}
                                                                    </span>
                                                                    {{canceledData['BookingDetails']['myCheckoutDateTime']['y']}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="clearfix"></div>
                                                        <div class="nigthcunt">Total No.of Night(s) -
                                                            {{getNoOfNights(canceledData['BookingDetails']['HotelCheckIn'], canceledData['BookingDetails']['HotelCheckOut'])}}
                                                        </div>
                                                        <div class="clearfix"></div>

                                                        <ng-container
                                                            *ngFor="let r of canceledData['BookingItineraryDetails']; index as i">
                                                            <div class="biginre_book">
                                                                {{r.BlockQuantity}} ×
                                                                <span class="bigdate_book">
                                                                    {{getRoomType(r.RoomTypeName)}}
                                                                </span>
                                                            </div>
                                                            <br>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 smch" style="padding-left: 0px;">
                                        <div class="farehd arimobold" style="margin-top: 0px;">Payment Details</div>
                                        <div class="fredivs">
                                            <div class="kindrest">
                                                <div class="reptallt valign-wrapper">
                                                    <div class="col-md-8 nopad">
                                                        <div class="faresty">Total</div>
                                                    </div>
                                                    <div class="col-md-4 nopad">
                                                        <div class="amnter"><span class="base_fare_span"></span> <span
                                                                class="base_fare_value0">
                                                                {{convert(getTotalAmnt(), canceledData['BookingItineraryDetails'][0]['Currency'])}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="reptallt valign-wrapper">
                                                    <div class="col-md-8 nopad">
                                                        <div class="faresty"> Cancellation Charge </div>
                                                    </div>
                                                    <div class="col-md-4 nopad">
                                                        <div class="amnter arimobold"><span
                                                                class="convenience_fees_span"></span> <span
                                                                class="convenience_fees_value">
                                                                {{convert(0, canceledData['BookingItineraryDetails'][0]['Currency'])}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="reptallt valign-wrapper">
                                                    <div class="col-md-8 nopad">
                                                        <div class="faresty">Convenience Fees</div>
                                                    </div>
                                                    <div class="col-md-4 nopad">
                                                        <div class="amnter arimobold"><span
                                                                class="convenience_fees_span"></span> <span
                                                                class="convenience_fees_value">
                                                                {{convert(0, canceledData['BookingItineraryDetails'][0]['Currency'])}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="reptallt valign-wrapper">
                                                    <div class="col-md-8 nopad">
                                                        <div class="faresty">Taxes &amp; Fees</div>
                                                    </div>
                                                    <div class="col-md-4 nopad">
                                                        <div class="amnter arimobold"><span
                                                                class="tax_fees_span"></span> <span
                                                                class="tax_fees_value">
                                                                {{convert(0, canceledData['BookingItineraryDetails'][0]['Currency'])}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="reptallt valign-wrapper">
                                                    <div class="col-md-8 nopad">
                                                        <div class="faresty">Discount</div>
                                                    </div>
                                                    <div class="col-md-4 nopad">
                                                        <div class="amnter arimobold"><span
                                                                class="convenience_fees_span"></span> <span
                                                                class="convenience_fees_value">
                                                                {{convert(0, canceledData['BookingItineraryDetails'][0]['Currency'])}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="clearfix"></div>
                                            <div class="reptalltftr valign-wrapper">
                                                <div class="col-md-6 nopad">
                                                    <div class="farestybig">Refund Amount </div>
                                                </div>
                                                <div class="col-md-6 nopad ">
                                                    <div class="amnterbig arimobold"><span class="grandtotal_span">
                                                        </span> <span class="total_booking_amount grandtotal_value">
                                                            {{convert(getTotalAmnt(), canceledData['BookingItineraryDetails'][0]['Currency'])}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <form style="width: 100%" (click)="backToSearch()">
                                <button type="submit" class="paysubmit" name="" id="continue" value="">
                                    <span class="bookbtn-wrapper">
                                        <span class="bookbtn-text">Back to search</span>
                                    </span>
                                    <span class="bookbtn-bgrnd-wrapper">
                                        <span class="bookbtn-idle" style="background-color: transparent;"></span>
                                        <span class="bookbtn-hover" style="background-color: #fff"></span>
                                    </span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #showError>
    <div class="qodefwrap">
        <div class="cancellation_dev">
            <div class="offset-md-3 col-md-6">
                <app-form-error-alert></app-form-error-alert>
            </div>
            <form style="width: 100%" (click)="backToSearch()">
                <button type="submit" class="paysubmit" name="" id="continue" value="">
                    <span class="bookbtn-wrapper">
                        <span class="bookbtn-text">Back to search</span>
                    </span>
                    <span class="bookbtn-bgrnd-wrapper">
                        <span class="bookbtn-idle" style="background-color: transparent;"></span>
                        <span class="bookbtn-hover" style="background-color: #fff"></span>
                    </span>
                </button>
            </form>

        </div>
    </div>
</ng-template> -->
